/* One shimmer for the whole page, stated once. The rail placeholders used
   Tailwind's `animate-pulse` on `bg-gray-200` while the full-page loader used it
   on `bg-gray-300`, so the two halves of one loading page breathed at different
   tones. `.sk-b` is the only skeleton surface now.

   The sheen animates background-position rather than opacity, because a column
   of dimming blocks reads as a page that is failing rather than arriving.
   `prefers-reduced-motion` drops it to a flat fill. */
export const SKELETON_STYLES = `
  .sk-b {
    background-color: #EDEFF0;
    background-image: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 100%);
    background-size: 200% 100%;
    background-repeat: no-repeat;
    background-position: -100% 0;
    border-radius: 4px;
    animation: sk-sheen 1.3s ease-in-out infinite;
  }
  @keyframes sk-sheen { to { background-position: 200% 0; } }
  @media (prefers-reduced-motion: reduce) {
    .sk-b { animation: none; background-image: none; }
  }

  /* The loader stands in for sections that have not arrived, so it borrows
     their frames rather than inventing its own metrics: same 40px/20px edge,
     same 32px rhythm, same surfaces. */
  .sk-sec { padding: 32px 0; }
  .sk-in { padding: 0 40px; width: 100%; box-sizing: border-box; }
  .sk-alt { background: #FAFBFB; }
  .sk-rail { display: flex; gap: 16px; overflow: hidden; }

  /* The rail card's footprint, class by class rather than inline, so the product
     tile steps down at the same two widths its real counterpart does — at 900px
     the real card is a third of the rail, which an inline one-fifth basis cannot
     follow. Body heights are the measured remainder that lands each skeleton
     section within ~2px of the section it stands in for. */
  /* Below 560px the real rail header stops reserving the arrow gutter and the
     arrows drop into the flow (RAIL_STYLES), making the section ~48px taller.
     Above that they cost nothing, so the stand-in only exists down there. */
  .sk-arrows { display: none; }
  /* Same width, same reason: the "View all …" link shares the header's row
     until 560px and drops onto its own line below it. */
  .sk-seeall { display: none; }
  @media (max-width: 560px) {
    .sk-arrows { display: flex; gap: 8px; justify-content: flex-end; margin: 0 0 12px; }
    .sk-arrows > .sk-b { width: 36px; height: 36px; border-radius: 50%; }
    .sk-seeall { display: block; height: 16px; width: 110px; margin-top: 6px; }
  }

  .sk-card {
    border: 1px solid #E5E7E8;
    border-radius: 4px;
    overflow: hidden;
    background: #FFFFFF;
  }
  .sk-card-brands { flex: 0 0 200px; }
  .sk-card-collections { flex: 0 0 230px; }
  .sk-card-products { flex: 0 0 calc((100% - 64px) / 5); }
  .sk-cbody { padding: 12px 13px; display: flex; flex-direction: column; gap: 8px; }
  .sk-cbody-brands { height: 31px; }
  .sk-cbody-products { height: 84px; }
  .sk-cbody-collections { height: 59px; }
  @media (max-width: 1024px) {
    .sk-card-products { flex: 0 0 calc((100% - 32px) / 3); }
  }
  @media (max-width: 860px) {
    .sk-card-products { flex: 0 0 210px; }
  }
  .sk-imgtext { display: grid; grid-template-columns: 1fr 1fr; gap: 36px; align-items: center; }
  .sk-foottop {
    display: grid;
    grid-template-columns: minmax(0, 3.5fr) minmax(0, 1fr) minmax(0, 1fr);
    gap: 32px;
    align-items: start;
  }
  .sk-foot { background: #FAFBFB; border-top: 1px solid #E5E7E8; padding: 44px 0 26px; }
  @media (max-width: 860px) {
    .sk-sec { padding: 28px 0; }
    .sk-in { padding: 0 20px; }
    .sk-foot { padding: 32px 0 22px; }
    .sk-imgtext { grid-template-columns: 1fr; gap: 22px; }
    .sk-foottop { grid-template-columns: 1fr; gap: 26px; }
  }
`;
